module.exports = __webpack_public_path__ + "img/coupon-popup-bg.e5813a6b.png";